import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/TermsOfService/termsOfService__fr-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout },
  seo: {
    ...sharedConfig['fr-FR'].seo,
    title: 'Conditions Générales d’Utilisation | Lemonade Assurance Habitation France',
    metaTitle: 'Conditions Générales d’Utilisation | Lemonade Assurance Habitation France',
    description:
      'Découvrez les conditions générales de Lemonade France pour tout savoir sur l’utilisation, les droits et les obligations de notre service d’assurance habitation.',
  },
  MDXContent: content as DocumentTypes,
};
